import { render, staticRenderFns } from "./groupD.vue?vue&type=template&id=3076ea9a&scoped=true"
import script from "./groupD.vue?vue&type=script&lang=js"
export * from "./groupD.vue?vue&type=script&lang=js"
import style0 from "./groupD.vue?vue&type=style&index=0&id=3076ea9a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3076ea9a",
  null
  
)

export default component.exports